import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { useMutationMarkOrderRetrieved } from '../../order-details.queries';
import { KnownOrderDtoStatus, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { mapHubToDeliveryContainerLabel } from '../order-details.utils';
import { Colors } from '../../../../../ui/theme/colors';

export function MarkRetrievedModal({
  order,
  onAbort,
  onSuccess
}: {
  order: OrderDto;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { onConfirm, state } = useConfirmationAction({
    mutationHook: useMutationMarkOrderRetrieved,
    mutationArgs: { retailerID: order.retailer.id, orderID: order.id },
    onSuccess,
    modalCloseDelay: 300
  });

  return (
    <ConfirmationModal
      title="Mark Retrieved?"
      content={makeModalContent(order)}
      onConfirm={onConfirm}
      onCancel={onAbort}
      actionButton={{
        label: 'Mark Retrieved',
        colorOverride: Colors.retrievedPurple
      }}
      cancelButton={{
        label: 'No'
      }}
      {...state}
    />
  );
}

function makeModalContent(order: OrderDto): string[] {
  const content = [`Marking the order Retrieved is for when you've removed the order and returned it to the store.`];
  const deliveryContainerLabel = mapHubToDeliveryContainerLabel(order.hub);

  if (assertIsIntermediateState(order.status)) {
    content[0] += ` We'll update the ${deliveryContainerLabel} state to reflect that it is now empty and the customer's collection code will no longer work.`;
    content.push(
      `If you need to take the order out of the ${deliveryContainerLabel}, you should Retrieve instead, or if it was given to the customer, mark it Collected.`
    );
  }

  content.push(`Are you sure?`);

  return content;
}
function assertIsIntermediateState(status: string) {
  return [KnownOrderDtoStatus.Delivered, KnownOrderDtoStatus.Overdue, KnownOrderDtoStatus.RetrievalRequired].includes(
    status as KnownOrderDtoStatus
  );
}
